<template>
  <WsMain>
    <slot></slot>
  </WsMain>
</template>

<script>
export default {};
</script>

<style>
</style>